import {useState} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.scss';

const propTypes = {
  title: PropTypes.string,
  variant: PropTypes.string,
  openTitle: PropTypes.string.isRequired,
  closeTitle: PropTypes.string.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  children: PropTypes.node.isRequired
};

const MobileAccordion = ({
  title,
  variant,
  openTitle,
  closeTitle,
  className,
  contentClassName = null,
  children
}) => {
  const [open, setOpen] = useState(false);

  const toggleAccordion = e => {
    e.preventDefault();

    setOpen(!open);
  };

  return (
    <div
      className={cx(className, {
        [styles['mobile-accordion']]: true,
        [styles['mobile-accordion--open']]: open,
        [styles[`mobile-accordion--${variant}`]]: variant
      })}>
      <button type="button" className={styles['mobile-accordion__title']} onClick={toggleAccordion}>
        {title !== null ? title : ''}

        {open ? closeTitle : openTitle}
      </button>

      <div className={cx(styles['mobile-accordion__content'], contentClassName)}>{children}</div>
    </div>
  );
};

MobileAccordion.propTypes = propTypes;

export default MobileAccordion;
